/* BG COM : pages kit (sections/bgcom-kit-clearmaxx). Sorti du HTML le 03/10/2026, chargé en defer ; une seule section kit par page ([data-bgk]). */
(function(){
  var root = document.querySelector('[data-bgk]');
  if(!root || root.getAttribute('data-bgk-init')) return;
  root.setAttribute('data-bgk-init', '1');
  var $ = function(s, r){ return (r || root).querySelector(s); };
  var $$ = function(s, r){ return [].slice.call((r || root).querySelectorAll(s)); };
  var mqR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EDIT = !!(window.Shopify && window.Shopify.designMode);
  var navE = (window.performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation')[0] : null;
  /* une arrivée normale seulement : pas au rechargement, en retour arrière, avec une ancre, dans l'éditeur ni en mouvement réduit */
  var FRESH = !mqR.matches && !EDIT && (!navE || navE.type === 'navigate') && !location.hash;
  /* le héros (balayage irisé + titre) joue aussi au rechargement ; jamais en retour arrière, avec une ancre, dans l'éditeur ni en mouvement réduit */
  var HERO = !mqR.matches && !EDIT && (!navE || navE.type !== 'back_forward') && !location.hash;
  var lines = $$('[data-bgk-line]');
  var UNIT1 = root.getAttribute('data-unit1') || 'équipement', UNITN = root.getAttribute('data-unitn') || 'équipements';
  var stage = $('[data-bgk-stage]'), fb = $('[data-bgk-fb]'), svg = $('[data-bgk-ldr]'), tipEl = $('[data-bgk-tip]'), panel = $('[data-bgk-panel]'), mbar = $('[data-bgk-mbar]');
  var FREE = 30000, PROMO = +root.getAttribute('data-promo') || 0, ALLSIZE = root.getAttribute('data-all-size') === '1';
  var PHOTO = root.classList.contains('bgk--photo');
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>';
  var CART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12.4a2 2 0 0 0 2 1.6h8.3a2 2 0 0 0 2-1.5L22 7H6"/></svg>';
  var live = false;

  /* le format monétaire de la boutique (€1.234,50), comme le bloc d'achat et le pack */
  function euros(c){ var n = Math.max(0, Math.round(c)); return '€' + String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ('0' + (n % 100)).slice(-2); }
  function eurosInt(c){ return '€' + String(Math.floor(Math.max(0, c) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(s){ return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function setTxt(el, t){ if(el && el.textContent !== String(t)) el.textContent = t; }
  function setNum(el, t, o){ if(!el) return; var M = window.BGM; if(live && M && typeof M.amount === 'function') M.amount(el, t, o); else { el.textContent = t; el.setAttribute('data-bgm-val', t); } }
  function isOut(li){ return li.classList.contains('is-out'); }
  function isMulti(li){ return li.getAttribute('data-multi') === '1'; }
  function selPill(li){ return li.querySelector('[data-bgk-pill].is-on'); }
  function ready(li){ return !isOut(li) && (!isMulti(li) || !!selPill(li)); }
  /* prix unitaire HT : celui de la variante choisie ; prix pro (appli Tarifs Pro) quand le client est pro, comme le pack */
  function unit(li){
    var price = +li.getAttribute('data-price'), first = +li.getAttribute('data-first') || price;
    var pro = li.querySelector('.bgcom-samita-target[data-customer="1"]');
    var w = window.bgcomWholesaleData && window.bgcomWholesaleData[li.getAttribute('data-pid')];
    return (pro && w && first) ? Math.round(price * w / first) : price;
  }

  /* ---------- étincelles irisées (géométrie de BGM.spark) ---------- */
  var SPK = [[-26,-18,7,'var(--i1)'],[24,-22,6,'var(--i2)'],[-30,14,6,'var(--i3)'],[28,16,7,'var(--i4)'],[2,-30,5,'var(--i2)'],[-4,28,5,'var(--i3)'],[40,-4,5,'var(--i1)'],[-42,-2,5,'var(--i4)']];
  function rel(el, host){ var a = el.getBoundingClientRect(), b = host.getBoundingClientRect(); return { x:a.left - b.left, y:a.top - b.top, w:a.width, h:a.height }; }
  function spark(host, ox, oy, n, k){
    if(mqR.matches || !host) return; k = k || 1;
    SPK.slice(0, n).forEach(function(s, j){
      var e = document.createElement('i'); e.className = 'bgk-spk';
      e.style.cssText = 'left:' + ox + 'px;top:' + oy + 'px;--x:' + Math.round(s[0] * k) + 'px;--y:' + Math.round(s[1] * k) + 'px;--s:' + s[2] + 'px;--c:' + s[3] + ';--d:' + (j * 40) + 'ms';
      host.appendChild(e); setTimeout(function(){ e.remove(); }, 700 + j * 40);
    });
  }

  /* ---------- pastilles de taille / couleur (pastille glissante) ---------- */
  function glide(box, anim){
    if(!box || mqR.matches) return;
    var on = box.querySelector('.bgk-pill.is-on'), g = box.querySelector('.bgk-glider');
    if(!on){ if(g) g.style.opacity = 0; return; }
    if(!g){ g = document.createElement('span'); g.className = 'bgk-glider'; box.insertBefore(g, box.firstChild); box.classList.add('is-glide'); anim = false; }
    if(!anim || g.style.opacity === '0') g.style.transition = 'none';
    g.style.opacity = 1; g.style.left = on.offsetLeft + 'px'; g.style.top = on.offsetTop + 'px'; g.style.width = on.offsetWidth + 'px'; g.style.height = on.offsetHeight + 'px';
    g.getBoundingClientRect(); g.style.transition = '';
  }
  function choose(li, pill){
    var was = selPill(li), on = was !== pill;
    li.querySelectorAll('[data-bgk-pill]').forEach(function(p){ var s = on && p === pill; p.classList.toggle('is-on', s); p.setAttribute('aria-checked', s ? 'true' : 'false'); });
    var vid = on ? pill.getAttribute('data-vid') : '', price = on ? pill.getAttribute('data-price') : li.getAttribute('data-v0-price');
    li.setAttribute('data-vid', vid); li.setAttribute('data-price', price); li.classList.remove('is-need');
    var opt = li.getAttribute('data-opt'), brand = li.getAttribute('data-brand');
    $('[data-bgk-szl]', li).innerHTML = esc(opt) + ' : <b>' + (on ? esc(pill.getAttribute('data-t')) : 'à choisir') + '</b>';
    $('[data-bgk-ref]', li).textContent = (brand ? brand + ' · ' : '') + (on && pill.getAttribute('data-sku') ? 'Réf. ' + pill.getAttribute('data-sku') : 'Réf. selon ' + opt.toLowerCase());
    /* le prix suit la variante : l'appli Tarifs Pro repeint, sinon on écrit le prix public */
    var cw = li.querySelector('.bgcom-card-wrap'), vv = on ? vid : li.getAttribute('data-v0');
    if(cw){ cw.setAttribute('data-variant-id', vv); cw.setAttribute('data-price', price); var tt = cw.querySelector('[data-samita-ttc]'); if(tt) tt.setAttribute('data-variant-id', vv); }
    var tg = cw && cw.querySelector('.bgcom-samita-target');
    if(tg && window.bgcomRenderPrices && tg.getAttribute('data-customer') === '1'){ delete tg.dataset.bgcomState; try{ window.bgcomRenderPrices(cw); }catch(_){} }
    else { var u = unit(li), ht = li.querySelector('.bgcom-price-ht .bgcom-money'), ttc = li.querySelector('.bgcom-price-ttc .bgcom-money'); if(ht) ht.textContent = euros(u); if(ttc) ttc.textContent = euros(u * 1.2); }
    glide(pill.parentNode, true);
    if(on && !mqR.matches && pill.animate){ try{ pill.animate([{ scale:'.9' }, { scale:'1' }], { duration:400, easing:'cubic-bezier(.34,1.56,.64,1)' }); }catch(_){} }
  }

  /* ---------- jauge « kit prêt » : un segment par pièce, au spectre du pack ---------- */
  var segs = $('[data-bgk-segs]'), meterLive = false;
  if(segs){
    var n = lines.length;
    segs.innerHTML = lines.map(function(li, i){ return '<span class="bgk-sg" title="' + (i + 1) + '. ' + esc(li.getAttribute('data-role')) + '"><i style="background-size:' + (n * 100) + '% 100%;background-position:' + (n > 1 ? i / (n - 1) * 100 : 0) + '% 0"></i></span>'; }).join('');
  }
  function paintSegs(stagger){
    if(!segs) return;
    [].forEach.call(segs.children, function(s, i){
      var li = lines[i], on = (meterLive || mqR.matches || !FRESH) && ready(li);
      s.firstChild.style.transitionDelay = stagger ? (i * 90) + 'ms' : '0ms';
      s.classList.toggle('is-on', on); s.classList.toggle('is-x', isOut(li));
    });
  }

  /* ---------- totaux, état du bouton, franco ---------- */
  var lastMiss = null, lastTot = null;
  function plural(n, a, b){ return n > 1 ? b : a; }
  function missLabel(n){ return ALLSIZE ? 'Choisissez ' + n + ' ' + plural(n, 'taille', 'tailles') : 'Choisissez ' + n + ' ' + plural(n, 'option', 'options'); }
  function totals(){
    var inn = lines.filter(function(li){ return !isOut(li); }), tot = 0, miss = 0, rdy = 0, full = 0;
    lines.forEach(function(li){ full += unit(li); });
    inn.forEach(function(li){ tot += unit(li); if(isMulti(li) && !selPill(li)) miss++; if(ready(li)) rdy++; });
    var pay = PROMO ? Math.round(tot * (100 - PROMO) / 100) : tot;
    setNum($('[data-bgk-total]'), euros(pay)); setNum($('[data-bgk-ttc]'), euros(pay * 1.2), { fade:true });
    var orig = $('[data-bgk-orig]'); if(orig) setTxt(orig, euros(tot));
    setTxt($('[data-bgk-mtot]'), euros(pay) + ' HT');
    var fig = $('[data-bgk-figtot]'); if(fig) setTxt(fig, eurosInt(PROMO ? Math.round(full * (100 - PROMO) / 100) : full));
    var cnt = inn.length + ' ' + plural(inn.length, UNIT1, UNITN) + ' sur ' + lines.length;
    setTxt($('[data-bgk-count]'), cnt);
    setTxt($('[data-bgk-mcnt]'), miss ? (ALLSIZE ? miss + ' ' + plural(miss, 'taille', 'tailles') + ' à choisir' : miss + ' ' + plural(miss, 'option', 'options') + ' à choisir') : cnt);
    var fr = $('[data-bgk-franco]'), ok = pay >= FREE; if(fr){ fr.classList.toggle('is-no', !ok); setTxt($('[data-bgk-franco-t]'), ok ? 'Ce kit est livré franco de port' : 'Franco de port dès 300 € HT'); }
    setTxt($('[data-bgk-mnum]'), rdy + ' sur ' + inn.length + ' ' + plural(rdy, 'prêt', 'prêts'));
    var ml = $('[data-bgk-mlbl]');
    if(ml) ml.innerHTML = !inn.length ? 'Kit vide' : miss ? esc(ALLSIZE ? miss + ' ' + plural(miss, 'taille', 'tailles') + ' à choisir' : miss + ' ' + plural(miss, 'option', 'options') + ' à choisir') : CHECK + 'Kit complet, prêt à commander';
    paintSegs(false);
    if(mbar) mbar.style.setProperty('--p', (inn.length ? rdy / inn.length * 100 : 0) + '%');
    $$('[data-bgk-buy]').forEach(function(b){
      if(b.classList.contains('is-busy') || b.classList.contains('is-done')) return;
      var mob = !!b.closest('[data-bgk-mbar]');
      if(!inn.length){ b.className = 'bgk-buy is-wait'; b.innerHTML = '<span data-bgk-buy-l>Cochez au moins un article</span>'; }
      else if(miss){ b.className = 'bgk-buy is-wait'; b.innerHTML = '<span data-bgk-buy-l>' + missLabel(miss) + '</span>'; }
      else { b.className = 'bgk-buy'; b.innerHTML = CART + '<span data-bgk-buy-l>' + (mob ? 'Ajouter le kit' : 'Ajouter le kit au panier') + '</span>'; }
    });
    if(live && lastTot != null && pay !== lastTot && meterLive && panel){ var t = $('[data-bgk-total]'); if(t && t.offsetParent){ var q = rel(t, panel); spark(panel, q.x + q.w + 8, q.y + q.h / 2, 4, .8); } }
    if(live && lastMiss > 0 && miss === 0 && inn.length) complete();
    lastMiss = miss; lastTot = pay;
    heroState();
  }
  function complete(){
    if(!segs) return;
    segs.classList.remove('is-shine'); void segs.offsetWidth; segs.classList.add('is-shine');
    if(segs.offsetParent){ var q = rel(segs, panel); spark(panel, q.x + q.w, q.y + 4, 6, 1); }
  }

  /* ---------- héros : points numérotés, légendes reliées, scan irisé ---------- */
  var G = [];
  (root.getAttribute('data-points') || '').split(/[;\n]+/).forEach(function(raw){
    var m = raw.trim().match(/^(\d+)(?:\s*[-à]\s*(\d+))?\s*:\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([GLDR]))?\s*(?:,\s*(.+))?$/i);
    if(!m) return;
    var a = +m[1] - 1, z = m[2] ? +m[2] - 1 : a, idx = [];
    for(var i = a; i <= z; i++){ if(lines[i]) idx.push(i); }
    if(!idx.length) return;
    var sd = (m[5] || '').toUpperCase(), side = (sd === 'G' || sd === 'L') ? 'L' : (sd === 'D' || sd === 'R') ? 'R' : (+m[3] < 50 ? 'L' : 'R');
    G.push({ idx:idx, x:+m[3], y:+m[4], side:side, name:(m[6] || lines[idx[0]].getAttribute('data-role')).trim() });
  });
  var NS = 'http://www.w3.org/2000/svg', built = false;
  function grpNum(g){ return g.idx.length > 1 ? (g.idx[0] + 1) + ' à ' + (g.idx[g.idx.length - 1] + 1) : String(g.idx[0] + 1); }
  function box(el, sr){ var r = el.getBoundingClientRect(); return { l:r.left - sr.left, t:r.top - sr.top, r:r.right - sr.left, b:r.bottom - sr.top }; }
  function hit(a, o, m){ return a.l < o.r + m && a.r > o.l - m && a.t < o.b + m && a.b > o.t - m; }
  /* un point = sa place au repos (offsetLeft/Top dans la photo), pas son rectangle animé (échelle .4 avant le scan) */
  function dotBox(d, sr){ var f = fb.getBoundingClientRect(), w = d.offsetWidth, h = d.offsetHeight, x = f.left - sr.left + d.offsetLeft, y = f.top - sr.top + d.offsetTop; return { l:x - w / 2, t:y - h / 2, r:x + w / 2, b:y + h / 2 }; }
  function obstacles(sr, except){
    var o = $$('.bgk-dot', stage).filter(function(d){ return d !== except; }).map(function(d){ return dotBox(d, sr); });
    var sg = $('.bgk-sign'); if(sg && sg.offsetWidth) o.push(box(sg, sr));
    return o;
  }
  /* la place la moins gênante : chaque obstacle couvert coûte 10, puis le côté, l'écart vertical et le recalage au bord */
  function bestSpot(w, h, cands, obs, SW, SH, B){
    var best = null, bestN = 1e9;
    B = B || { x0:10, x1:SW - w - 10, y0:10, y1:SH - h - 10 };
    cands.forEach(function(c){
      var l = Math.max(B.x0, Math.min(B.x1, c.l)), t = Math.max(B.y0, Math.min(B.y1, c.t));
      var r = { l:l, t:t, r:l + w, b:t + h, side:c.side };
      var n = obs.filter(function(o){ return hit(r, o, 6); }).length * 10 + (c.cost || 0) + Math.abs(l - c.l) / 40 + Math.abs(t - c.t) / 40;
      if(n < bestN){ bestN = n; best = r; best.n = obs.filter(function(o){ return hit(r, o, 6); }).length; }
    });
    return best;
  }
  function buildHero(){
    if(!fb || !G.length) return;
    G.forEach(function(g, gi){
      var d = document.createElement('button'); d.type = 'button'; d.className = 'bgk-dot' + (g.idx.length > 1 ? ' is-grp' : ''); d.setAttribute('data-g', gi);
      d.style.left = g.x + '%'; d.style.top = g.y + '%'; d.textContent = grpNum(g);
      d.setAttribute('aria-label', g.idx.map(function(i){ return (i + 1) + '. ' + lines[i].getAttribute('data-role'); }).join(', '));
      fb.appendChild(d);
      var l = document.createElement('button'); l.type = 'button'; l.className = 'bgk-lab'; l.setAttribute('data-g', gi); l.setAttribute('tabindex', '-1'); l.setAttribute('aria-hidden', 'true'); stage.appendChild(l);
      var gg = document.createElementNS(NS, 'g'); gg.setAttribute('data-g', gi);
      gg.appendChild(document.createElementNS(NS, 'path')); var c = document.createElementNS(NS, 'circle'); c.setAttribute('r', '2.5'); gg.appendChild(c); svg.appendChild(gg);
    });
    var hint = $('[data-bgk-hint]'); if(hint) hint.hidden = false;
    built = true; heroState(); layout();
  }
  function heroState(){
    if(!built) return;
    G.forEach(function(g, gi){
      var off = g.idx.every(function(i){ return isOut(lines[i]); }), sum = 0;
      g.idx.forEach(function(i){ if(!isOut(lines[i])) sum += unit(lines[i]); });
      var l = $('.bgk-lab[data-g="' + gi + '"]'), em = '<em>' + grpNum(g) + '</em>', left = l.classList.contains('is-l');
      var h = '<b>' + (left ? esc(g.name) + em : em + esc(g.name)) + '</b><span>' + (off ? 'déjà équipé' : (g.idx.length > 1 ? g.idx.length + ' réf. · ' : '') + euros(sum) + ' HT') + '</span>';
      if(l.innerHTML !== h) l.innerHTML = h;
      l.classList.toggle('is-off', off); $('.bgk-dot[data-g="' + gi + '"]').classList.toggle('is-off', off);
    });
  }
  function layout(){
    if(!built) return;
    var sr = stage.getBoundingClientRect(), fr = fb.getBoundingClientRect();
    if(!sr.width || !fr.width) return;
    var fl = fr.left - sr.left, ft = fr.top - sr.top, fw = fr.width, fh = fr.height, SW = sr.width, SH = sr.height;
    var labs = $$('.bgk-lab', stage);
    stage.classList.remove('is-nolab');
    var small = SW < 360 || window.innerWidth < 750;
    var hintT = $('[data-bgk-hint] span'); if(hintT) setTxt(hintT, window.matchMedia('(hover: hover)').matches ? 'Cliquez sur un point pour voir la pièce' : 'Touchez un point pour voir la pièce');
    svg.setAttribute('viewBox', '0 0 ' + SW + ' ' + SH);
    if(small){ stage.classList.add('is-nolab'); return; }
    /* côté posé avant de mesurer (le texte change de sens) */
    G.forEach(function(g, gi){ labs[gi].classList.toggle('is-l', g.side === 'L'); });
    heroState();
    var maxW = Math.max.apply(null, labs.map(function(l){ return l.offsetWidth; }));
    var outside = !PHOTO && fl - 30 >= maxW;   /* détourage : légendes hors silhouette ; photo : légendes à côté du point */
    /* obstacles : tous les points et le bloc des logos ; chaque légende essaie plusieurs places et garde celle qui ne couvre rien */
    var obs = obstacles(sr), placed = [], crowded = false;
    G.forEach(function(g, gi){
      var l = labs[gi], d = $('.bgk-dot[data-g="' + gi + '"]'), dw = d.offsetWidth / 2;
      var dx = fl + g.x / 100 * fw, dy = ft + g.y / 100 * fh, lw = l.offsetWidth, lh = l.offsetHeight;
      function at(sd){ return outside ? (sd === 'L' ? fl - 16 : fl + fw + 16) : (sd === 'L' ? dx - dw - 28 : dx + dw + 28); }
      var cands = [];
      [g.side, g.side === 'L' ? 'R' : 'L'].forEach(function(sd, si){
        [0, -26, 26, -52, 52, -78, 78, -104, 104].forEach(function(off){
          var x2 = at(sd); cands.push({ l:sd === 'L' ? x2 - lw : x2, t:dy - lh / 2 + off, side:sd, cost:si * 3 + Math.abs(off) / 26 });
        });
      });
      var spot = bestSpot(lw, lh, cands, obs.concat(placed), SW, SH);
      if(spot.n) crowded = true;
      placed.push(spot);
      var side = spot.side; l.classList.toggle('is-l', side === 'L');
      l.style.left = spot.l + 'px'; l.style.top = spot.t + 'px';
      var ly = spot.t + lh / 2, x1 = side === 'L' ? dx - dw - 4 : dx + dw + 4, xe = side === 'L' ? spot.r : spot.l;
      var gg = svg.querySelector('g[data-g="' + gi + '"]'), p = gg.firstChild, c = gg.lastChild, elbow = side === 'L' ? xe + 18 : xe - 18;
      if((side === 'L' && xe > x1) || (side === 'R' && xe < x1)){ x1 = dx; }
      p.setAttribute('d', Math.abs(ly - dy) < 2 ? 'M' + x1 + ' ' + dy + 'H' + xe : 'M' + x1 + ' ' + dy + 'H' + elbow + 'L' + xe + ' ' + ly);
      c.setAttribute('cx', xe); c.setAttribute('cy', ly);
      var len = Math.ceil(p.getTotalLength ? p.getTotalLength() : 200);
      p.style.strokeDasharray = len; p.style.strokeDashoffset = gg.classList.contains('is-in') || !root.classList.contains('bgk--anim') ? 0 : len;
    });
    if(crowded) stage.classList.add('is-nolab');
    heroState();
  }
  function popGroup(gi){
    var d = $('.bgk-dot[data-g="' + gi + '"]'), gg = svg.querySelector('g[data-g="' + gi + '"]'), l = $('.bgk-lab[data-g="' + gi + '"]');
    d.classList.add('is-in');
    setTimeout(function(){ gg.classList.add('is-in'); gg.firstChild.style.strokeDashoffset = 0; }, 160);
    setTimeout(function(){ l.classList.add('is-in'); }, 360);
  }
  function scan(){
    var sc = $('[data-bgk-scan]'), sr = stage.getBoundingClientRect(), fr = fb.getBoundingClientRect();
    var ft = fr.top - sr.top, fh = fr.height, popped = {}, D0 = 1200, t0 = null, done = false;
    var order = G.map(function(g, gi){ return { gi:gi, y:ft + g.y / 100 * fh }; });
    sc.className = 'bgk-scan is-on'; sc.style.transform = 'translateY(' + ft + 'px)';
    function ease(k){ return k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2; }
    function finish(){ if(done) return; done = true; order.forEach(function(o){ if(!popped[o.gi]){ popped[o.gi] = 1; popGroup(o.gi); } }); sc.className = 'bgk-scan is-end'; }
    function step(t){
      if(done) return; if(t0 == null) t0 = t;
      var k = Math.min(1, (t - t0) / D0), y = ft + ease(k) * fh;
      sc.style.transform = 'translateY(' + y + 'px)';
      order.forEach(function(o){ if(!popped[o.gi] && o.y <= y + 6){ popped[o.gi] = 1; popGroup(o.gi); } });
      if(k < 1) requestAnimationFrame(step); else finish();
    }
    requestAnimationFrame(step);
    setTimeout(finish, D0 + 1500);   /* filet : onglet caché, rAF gelé */
  }
  function tip(d){
    var g = G[+d.getAttribute('data-g')];
    $$('.bgk-dot', stage).forEach(function(x){ x.classList.toggle('is-on', x === d); });
    tipEl.innerHTML = g.idx.map(function(i, k){
      var li = lines[i], rng = li.getAttribute('data-range');
      return '<div' + (k ? ' class="s"' : '') + '><div class="r">' + (i + 1) + '. ' + esc(li.getAttribute('data-role')) + '</div><div class="t">' + esc(li.getAttribute('data-name')) + '</div><div class="p">' + euros(unit(li)) + ' HT' + (rng && !selPill(li) ? '<small>' + (/taille|pointure/i.test(li.getAttribute('data-opt')) ? 'tailles ' + esc(rng) : li.querySelectorAll('[data-bgk-pill]').length + ' ' + esc(li.getAttribute('data-opt').toLowerCase()) + 's') + '</small>' : '') + '</div></div>';
    }).join('') + '<a href="#" data-bgk-go="' + g.idx[0] + '">Voir dans le kit</a>';
    var media = stage.parentNode, mr = media.getBoundingClientRect(), sr = stage.getBoundingClientRect(), vw = document.documentElement.clientWidth;
    var W = Math.min(250, vw - 16), gap = 14;
    tipEl.style.width = W + 'px';
    var H = tipEl.offsetHeight, ox = sr.left - mr.left, oy = sr.top - mr.top;
    function inMedia(b){ return { l:b.l + ox, t:b.t + oy, r:b.r + ox, b:b.b + oy }; }
    var q = inMedia(dotBox(d, sr)), cy = (q.t + q.b) / 2, cx = (q.l + q.r) / 2, cands = [];
    var fbr = fb.getBoundingClientRect(), FR = { l:fbr.right - mr.left + 16 }, FL = { l:fbr.left - mr.left - W - 16 };
    var R = { l:q.r + gap }, L = { l:q.l - W - gap }, order = g.side === 'L' ? [L, R, FL, FR] : [R, L, FR, FL];   /* puis hors silhouette */
    order.forEach(function(o, i){ for(var j = 0; j <= 12; j++){ var off = -20 - j * 20; if(off < -H - 40) break; cands.push({ l:o.l, t:cy + off, cost:i * 2 + j * .3 }); cands.push({ l:o.l, t:cy - 20 + j * 20, cost:i * 2 + j * .3 + .1 }); } });
    cands.push({ l:cx - W / 2, t:q.b + 10, cost:5 }, { l:cx - W / 2, t:q.t - H - 10, cost:6 });
    var obs = $$('.bgk-dot', stage).filter(function(x){ return x !== d; }).map(function(x){ return inMedia(dotBox(x, sr)); });
    obs.push(q);
    var sg = $('.bgk-sign'); if(sg && sg.offsetWidth) obs.push(box(sg, mr));
    /* la carte peut déborder de la photo (sur la marge ou la colonne de texte), jamais de l'écran */
    var spot = bestSpot(W, H, cands, obs, 0, 0, { x0:-mr.left + 8, x1:vw - mr.left - W - 8, y0:oy + 8, y1:oy + sr.height - H - 8 });
    tipEl.style.left = spot.l + 'px'; tipEl.style.top = spot.t + 'px';
    tipEl.classList.add('is-on');
  }
  function closeTip(){ tipEl.classList.remove('is-on'); $$('.bgk-dot.is-on', stage).forEach(function(x){ x.classList.remove('is-on'); }); }
  function goRow(i){
    var li = lines[i]; if(!li) return;
    li.scrollIntoView({ behavior:mqR.matches ? 'auto' : 'smooth', block:'center' });
    li.classList.add('is-hot'); setTimeout(function(){ li.classList.remove('is-hot'); }, 1600);
  }

  /* ---------- ajout au panier : une ligne par référence, puis le tiroir Espace Pro ---------- */
  function say(h, err){ var m = $('[data-bgk-msg]'); if(!m) return; m.innerHTML = h || ''; m.classList.toggle('is-err', !!err); }
  function buy(b){
    if(b.classList.contains('is-busy') || b.classList.contains('is-done')) return;
    var inn = lines.filter(function(li){ return !isOut(li); });
    if(b.classList.contains('is-wait')){
      if(!inn.length) return;
      var first = null;
      lines.forEach(function(li){ var need = !isOut(li) && isMulti(li) && !selPill(li); li.classList.remove('is-need'); if(need){ void li.offsetWidth; li.classList.add('is-need'); if(!first) first = li; } });
      if(first) first.scrollIntoView({ behavior:mqR.matches ? 'auto' : 'smooth', block:'center' });
      return;
    }
    var items = inn.map(function(li){ return { id:+(li.getAttribute('data-vid') || li.getAttribute('data-v0')), quantity:1 }; });
    var btns = $$('[data-bgk-buy]');
    btns.forEach(function(x){ x.classList.add('is-busy'); x.innerHTML = '<span class="bgk-spin" aria-hidden="true"></span><span data-bgk-buy-l>Ajout en cours</span>'; });
    say('');
    fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ items:items }) })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function(c){ c.textContent = cart.item_count; });
        if(window.bgcomRefreshCartCount){ try{ window.bgcomRefreshCartCount(); }catch(_){} }
        document.dispatchEvent(new CustomEvent('bgh:added', { detail:{ cart:cart } }));
        document.dispatchEvent(new CustomEvent('bgcom:kit:added'));
        btns.forEach(function(x){ x.classList.remove('is-busy'); x.classList.add('is-done'); x.innerHTML = CHECK + '<span data-bgk-buy-l>Kit ajouté</span>'; });
        var pb = panel && panel.querySelector('[data-bgk-buy]');
        if(pb && pb.offsetParent){ var q = rel(pb, panel); spark(panel, q.x + q.w / 2, q.y + q.h / 2, 8, 2.4); }
        say(items.length + ' ' + plural(items.length, 'article ajouté', 'articles ajoutés') + ' au panier. <a href="/cart">Voir le panier</a>');
        /* le panier du site est le tiroir Espace Pro (appli Fly), comme le pack de la fiche */
        try{ if(typeof window.bgproOpen === 'function') window.bgproOpen(); else { var cd = document.querySelector('cart-drawer'); if(cd && cd.show) cd.show(); } }catch(_){}
        setTimeout(function(){ btns.forEach(function(x){ x.classList.remove('is-done'); }); totals(); }, 3500);
      })
      .catch(function(e){
        btns.forEach(function(x){ x.classList.remove('is-busy'); });
        totals();
        say(esc((e && (e.description || e.message)) ? String(e.description || e.message) : 'L’ajout n’a pas abouti, réessayez.'), true);
      });
  }

  /* ---------- événements ---------- */
  root.addEventListener('click', function(e){
    var t = e.target;
    var d = t.closest('.bgk-dot'); if(d){ if(d.classList.contains('is-on')) closeTip(); else tip(d); return; }
    var lb = t.closest('.bgk-lab'); if(lb){ goRow(G[+lb.getAttribute('data-g')].idx[0]); return; }
    var go = t.closest('[data-bgk-go]'); if(go){ e.preventDefault(); closeTip(); goRow(+go.getAttribute('data-bgk-go')); return; }
    if(!t.closest('[data-bgk-tip]')) closeTip();
    var inc = t.closest('[data-bgk-inc]');
    if(inc){ var li = inc.closest('[data-bgk-line]'), out = !isOut(li); li.classList.toggle('is-out', out); li.classList.remove('is-need'); inc.setAttribute('aria-checked', out ? 'false' : 'true'); totals(); return; }
    var pl = t.closest('[data-bgk-pill]'); if(pl && !pl.disabled){ choose(pl.closest('[data-bgk-line]'), pl); totals(); return; }
    var b = t.closest('[data-bgk-buy]'); if(b) buy(b);
  });
  document.addEventListener('click', function(e){ if(!root.contains(e.target)) closeTip(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeTip(); });
  root.addEventListener('mouseover', function(e){
    var h = e.target.closest('.bgk-dot, .bgk-lab');
    $$('.bgk-dot.is-hi, .bgk-lab.is-hi', stage).forEach(function(x){ x.classList.remove('is-hi'); }); if(svg) $$('g.is-hi', svg).forEach(function(x){ x.classList.remove('is-hi'); });
    if(!h) return;
    var gi = h.getAttribute('data-g');
    $$('[data-g="' + gi + '"]', stage).forEach(function(x){ if(x !== h) x.classList.add('is-hi'); });
  });

  /* ---------- apparitions (une fois, quand le haut atteint 80 % de l'écran ; rien sans observateur) ---------- */
  function words(h){
    var k = 0;
    function wrap(node, into){
      node.textContent.split(/(\s+)/).forEach(function(w){ if(!w) return; if(/^\s+$/.test(w)) into.appendChild(document.createTextNode(' ')); else { var s = document.createElement('span'); s.className = 'bgk-w'; s.textContent = w; s.style.setProperty('--d', (k++ * 90) + 'ms'); into.appendChild(s); } });
    }
    [].slice.call(h.childNodes).forEach(function(n){
      if(n.nodeType === 3){ var f = document.createDocumentFragment(); wrap(n, f); h.replaceChild(f, n); }
      else if(n.tagName === 'I'){ var s = document.createElement('span'); s.className = 'bgk-w'; s.style.setProperty('--d', (k++ * 90) + 'ms'); h.replaceChild(s, n); s.appendChild(n); }
      else if(n.tagName === 'B'){ var txt = document.createTextNode(n.textContent); n.textContent = ''; n.appendChild(txt); wrap(txt, n); n.removeChild(txt); }
    });
    return k;
  }
  var io = null, ioAnswered = false;
  function below(el){ var r = el.getBoundingClientRect(); return r.top > window.innerHeight * .8; }
  function watch(el, cls, fn){
    if(!FRESH || !('IntersectionObserver' in window) || !below(el)){ if(fn) fn(el, false); return; }
    el.classList.add(cls); el._bgk = fn || null;
    io.observe(el);
  }
  function reveal(){
    if('IntersectionObserver' in window){
      io = new IntersectionObserver(function(es){
        ioAnswered = true;
        es.forEach(function(en){ if(en.isIntersecting){ io.unobserve(en.target); en.target.classList.add('is-in'); if(en.target._bgk) en.target._bgk(en.target, true); } });
      }, { rootMargin:'0px 0px -20% 0px' });
    }
    /* titre du héros : mot à mot à l'arrivée seulement (au-dessus de la ligne de flottaison, jamais caché sans script) */
    var h1 = $('.bgk-h--1');
    if(HERO && h1 && window.scrollY < 40){
      var hn = words(h1); h1.classList.add('is-ww');
      var kids = $$('[data-bgk-copy] > :not(h1)');
      kids.forEach(function(el, j){ if(el.matches('.bgk-micro')){ return; } el.style.setProperty('--d', (hn * 90 + j * 90) + 'ms'); el.classList.add('is-w'); });
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ h1.classList.add('is-in'); kids.forEach(function(el){ el.classList.add('is-in'); }); }); });
    }
    var h2 = $('.bgk-dk .bgk-h');
    if(h2 && FRESH && 'IntersectionObserver' in window && below(h2)){ words(h2); watch(h2, 'is-ww'); }
    $$('[data-bgk-rv]').forEach(function(el){ watch(el, 'is-w'); });
    var list = $('[data-bgk-list]'); if(list) watch(list, 'is-wl');
    if(panel) watch(panel, 'bgk-noop', function(el, anim){ setTimeout(function(){ meterLive = true; paintSegs(anim); }, anim ? 300 : 0); });
    /* filet de sécurité : sans réponse de l'observateur, tout s'affiche */
    setTimeout(function(){ if(!ioAnswered) $$('.is-w, .is-ww, .is-wl', root).forEach(function(el){ el.classList.add('is-in'); }); if(!meterLive){ meterLive = true; paintSegs(false); } }, 2500);
  }

  /* ---------- barre basse : s'efface devant le panneau, évite la bulle de chat et le dock ---------- */
  var away = false;
  function chatRect(){
    var own = document.querySelector('.bgcom-chat.is-on [data-bgcom-chat-box]');   /* bouton de chat Mister Paint (snippets/bgcom-chat-launcher) */
    if(own){   /* pastille + tête qui dépasse + liseré, hors animation (offset* ignore les transform) */
      var an = own.parentNode, fe = own.querySelector('.bgcom-chat__face');
      if(!an || !own.offsetWidth) return null;
      var x0 = an.offsetLeft, y0 = an.offsetTop, fx = fe ? fe.offsetLeft : 0, fy = fe ? fe.offsetTop : 0;
      var L = x0 + Math.min(0, fx) - 2, T = y0 + Math.min(0, fy) - 2;
      var R = x0 + Math.max(own.offsetWidth, fe ? fx + fe.offsetWidth : 0) + 2, B = y0 + Math.max(own.offsetHeight, fe ? fy + fe.offsetHeight : 0) + 2;
      return { left:L, top:T, right:R, bottom:B, width:R - L, height:B - T };
    }
    var c = document.querySelector('shopify-chat, inbox-online-store-chat'), r0 = c && c.shadowRoot; if(!r0) return null;
    var a = r0.querySelector('button.activator, .activator, button[aria-label]'); if(!a) return null;
    var r = a.getBoundingClientRect(); return (r.width && r.height && r.bottom > 0) ? r : null;
  }
  function placeBar(){
    if(!mbar || getComputedStyle(mbar).display === 'none') return;
    var vw = document.documentElement.clientWidth, vh = window.innerHeight, right = 8, bottom = 8, compact = false;
    var dock = document.querySelector('mobile-dock, .mobile-dock');
    if(dock){ var dr = dock.getBoundingClientRect(); if(dr.height && dr.top < vh - 2) bottom = Math.round(vh - dr.top + 8); }
    var r = chatRect();
    if(r && r.top > vh * .5){
      var nr = Math.round(vw - r.left + 8), room = vw - 8 - nr;
      if(room >= 230){ right = nr; compact = room < 340; } else bottom = Math.max(bottom, Math.round(vh - r.top + 12));
    }
    mbar.style.setProperty('--bgk-mr', right + 'px'); mbar.style.setProperty('--bgk-mb', bottom + 'px');
    mbar.classList.toggle('is-compact', compact);
  }
  function setAway(){ if(!mbar) return; mbar.classList.toggle('is-away', away); mbar.setAttribute('aria-hidden', away ? 'true' : 'false'); var b = mbar.querySelector('[data-bgk-buy]'); if(b) b.tabIndex = away ? -1 : 0; }
  function gates(){
    if(!('IntersectionObserver' in window) || !panel) return;
    /* l'anneau ne tourne qu'à l'écran (BGM.gate) ; la barre basse cède la place au panneau et au héros */
    new IntersectionObserver(function(es){ es.forEach(function(en){ panel.classList.toggle('is-paused', !en.isIntersecting); }); }).observe(panel);
  }
  function barState(force){
    if(!mbar || !panel) return;
    var vh = window.innerHeight, p = panel.getBoundingClientRect(), cta = $('.bgk-cta'), c = cta ? cta.getBoundingClientRect() : null;
    var a = (p.top < vh * .9 && p.bottom > 0) || (c ? c.bottom > 0 : false);
    if(force || a !== away){ away = a; setAway(); }
  }

  /* en-tête collant : le panneau se cale dessous */
  function headTop(){
    var h = document.querySelector('header.header'), s = h && (h.closest('.shopify-section') || h);
    var hh = (s && getComputedStyle(s).position === 'sticky') ? Math.round(h.getBoundingClientRect().height) : 0;
    root.style.setProperty('--bgk-top', (hh + 24) + 'px');
  }

  function init(){
    if(HERO && fb && G.length) root.classList.add('bgk--anim');
    lines.forEach(function(li){ var pl = li.querySelector('.bgk-pills'); if(pl) glide(pl, false); });
    totals();
    reveal();
    var img = $('[data-bgk-img]');
    /* le balayage part quand la photo est à l'écran (au chargement : tout de suite) */
    var go = function(){
      buildHero();
      if(!root.classList.contains('bgk--anim')) return;
      if(!('IntersectionObserver' in window)){ setTimeout(scan, 500); return; }
      var so = new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ so.disconnect(); setTimeout(scan, 400); } }); }, { threshold:.35 });
      so.observe(stage);
    };
    if(!img || (img.complete && img.naturalWidth)) go(); else { img.addEventListener('load', go, { once:true }); img.addEventListener('error', go, { once:true }); }
    gates(); headTop(); placeBar();
    var h = document.querySelector('header.header'); if(h && window.ResizeObserver) new ResizeObserver(headTop).observe(h);
    var rz; window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(function(){ layout(); placeBar(); $$('.bgk-pills').forEach(function(p){ glide(p, false); }); }, 120); }, { passive:true });
    var sc; window.addEventListener('scroll', function(){ if(sc) return; sc = requestAnimationFrame(function(){ sc = null; placeBar(); barState(); }); }, { passive:true });
    barState(true);
    [1200, 3500, 8000].forEach(function(t){ setTimeout(function(){ placeBar(); totals(); }, t); });   /* prix pro repeints après coup */
    requestAnimationFrame(function(){ live = true; });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
